import {Box, Drawer} from '@mui/material';
import {styled} from '@mui/material/styles';

export const StyledBasket = styled(Drawer)(() => ({
  display: 'flex',
  flexDirection: 'column',
  '& .MuiDrawer-paper': {
    width: '-webkit-fill-available',
    border: 'none',
    '& > div:nth-of-type(2)': {
      flex: '1 1 0%'
    }
  },
  transition: 'none'
}));

export const StyledSectionWrap = styled(Box)(({theme}) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  position: 'relative',
  backgroundColor: theme.palette.common.white,
  '&.multiple': {
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2)
    }
  },
  '&.v2': {
    marginBottom: theme.spacing(0.15)
  }
}));

export const StyledSectionContentContainer = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  position: 'relative'
}));

export const StyledProductInfoWrapper = styled(Box)<{isUnavailable: boolean}>(({isUnavailable}) => ({
  opacity: isUnavailable ? 0.6 : 1
}));
